/**
 * Component: Script for the password page
 * -----------------------------------------------------------------------------
 * Has minimal logic for the login form.
 *
 */
import classes from '~/config/classes'

/**
 * DOM selectors.
 */
const selectors = {
  toggle: '[js-password="toggle"]',
  form: '[js-password="form"]',
  login: '[js-password="login"]',
}

/**
 * Create a new example object.
 */
export default () => {

  /**
   * DOM node selectors.
   */
  const nodeSelectors = {
    toggle: document.querySelector(selectors.toggle),
    form: document.querySelector(selectors.form),
    login: document.querySelector(selectors.login),
  }

  /**
   * Initialise component.
   */
  function init() {
    setEventListeners()
    showPasswordForm()
  }

  /**
   * Set event listeners.
   */
  function setEventListeners() {
    nodeSelectors.toggle.addEventListener('click', () => {
      nodeSelectors.form.classList.toggle(classes.hidden)
    })
  }

  /**
   * Check if password form should be visible event
   */
  function showPasswordForm() {
    const searchParams = new URLSearchParams(window.location.search.toLowerCase())

    if (searchParams.has('login')) {
      if (!nodeSelectors.login) {
        return
      }

      nodeSelectors.login.setAttribute('aria-hidden', false)
    }
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  })
}
